import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineEyeInvisible} from "react-icons/ai";
import {useNavigate} from "react-router-dom"
import LoginNav from '../components/navber/LoginNav';

const LoginPage = () => {
  const [phone, setphone] = useState("")
  const [password, setpassword] = useState("")
  const [state,setState] = useState(false)
  const navigate = useNavigate()


  useEffect(() => {
    window.scroll(0,0)
  }, [])


    const handelSubmit = (e)=>{
        e.preventDefault();
        navigate("/profile")

    }

  const trogalButton=(e)=>{
    e.preventDefault();
    setState(prevState=>!prevState)
  }

  return (
    <>
    <LoginNav/>
    <div className='md:pt-[120px] pt-[90px]'>
    <div className="container">
        <div className='max-w-[500px] m-auto'>
            <div className='headding mb-4'>
                <h2 className='md:text-[59px] text-[32px] md:leading-[81px] leading-[37px] font-bold'>Inicia sesión</h2>
                <p className='md:text-[24px] text-[14px] mt-1'>Bienvenid@ de vuelta </p>
            </div>

                <form action="" onSubmit={handelSubmit}>
                        <div  className='flex items-center flex-col md:flex-row gap-0  md:gap-[100px] w-full'>
                        <div className='w-full'>
                        <div className='py-2'>
                            <label htmlFor='phone' className='ml-5 text-[20px]'>Número celular</label>
                            <input type="text" id='phone' className='input_Box text-[20px] w-full py-2 px-2' value={phone} onChange={(e)=>setphone(e.target.value)} />
                        </div>
                        <div className='py-2'>
                            <label htmlFor='Contraseña' className='ml-5 text-[20px]'>Contraseña</label>
                            <div className=' relative'>
                            <input type={`${state?"text" : "password"}`} id='Contraseña' className='input_Box text-[20px] w-full py-2 px-2' value={password} onChange={(e)=>setpassword(e.target.value)} />
                            <button className="text-[24px] absolute right-[10px] top-[30%]" onClick={trogalButton}>{
                                state? <AiOutlineEye /> : <AiOutlineEyeInvisible />
                            }</button>
                            </div>
                        </div>
                        <div className=' text-right'>
                        <Link className='  border-b border-gray-400 text-right' to={"/forget-password"}>Olvidé mi contraseña</Link>
                        </div>
                    </div>
                        </div>
                        <div className='flex items-center gap-5 py-6'>
                              <input type="checkbox" id='chke' className='chakbox' />
                            <label className='md:text-[24px] lg:w-full text-[14px] font-normal' htmlFor="chke">Recordar mi información</label>
                        </div>
                        <div>
                            <button type='submit' className='py-4 px-5 bg-[#4285F4] text-white text-[14px] font-medium rounded-md md:text-[24px]'>Iniciar sesión</button>
                            <p className='md:text-[24px] text-[14px] font-normal mt-5'>¿Aún no tienes una cuenta? <Link className='  border-b border-gray-400' to={"/signup"}>Regístrate aquí</Link></p>
                        </div>
                   
                </form>
        </div>
    </div>
</div>
    </>
  )
}

export default LoginPage